import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ClanTag from '../ClanTag/ClanTag'

import styles from './Member.css'

const propTypes = {
    name: PropTypes.string.isRequired,
    status: PropTypes.oneOf(['offline', 'online', 'busy']),
    clanTag: PropTypes.string,
    clanColor: PropTypes.string,
    isFriend: PropTypes.bool,
    isOwn: PropTypes.bool,
    tooltipId: PropTypes.string,
    onContextMenu: PropTypes.func,
}

const defaultProps = {
    onContextMenu: () => {},
}

class Member extends React.PureComponent {
    render() {
        const classNameBase = classNames(styles.base, {
            [styles[`base__${this.props.status}`]]: this.props.status,
            [styles.isFriend]: this.props.isFriend,
            [styles.isOwn]: this.props.isOwn,
        })

        const clanTag = this.props.clanTag && this.props.clanColor ? (
            <div className={styles.clanTag}>
                <ClanTag
                    tag={this.props.clanTag}
                    color={this.props.clanColor}
                />
            </div>
        ) : null

        const dataAttrs = this.props.tooltipId ? {
            'data-tip': true,
            'data-for': this.props.tooltipId,
        } : {}

        return (
            <div
                className={classNameBase}
                onContextMenu={this.props.onContextMenu}
                {...dataAttrs}
            >
                {clanTag}
                {this.props.name}
            </div>
        )
    }
}

Member.propTypes = propTypes
Member.propTypes = defaultProps

export default Member



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/Member/Member.jsx